import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import { Button, Grid, Typography, styled } from "@material-ui/core";

import { lang } from "../../../i18nLang";

const Title = styled(Typography)({
  fontSize: "15rem",
  fontWeight: 500,
});

const Page404 = ({ title }: { title? }) => {
  const history = useHistory();

  const handleClickHome = () => history.push("/kanban");
  const handleClickBack = () => history.goBack();

  return (
    <Grid
      container
      item
      xs
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Title variant="h1" color="primary">
        404
      </Title>
      <Typography variant="h5">
        {title || lang("errorPages.notFound")}
      </Typography>
      <Button
        variant="outlined"
        color="primary"
        size="large"
        style={{ marginTop: "1.25rem" }}
        onClick={handleClickHome}
      >
        {lang("returnHome")}
      </Button>
      <Button
        variant="outlined"
        color="primary"
        size="large"
        style={{ marginTop: "0.5rem" }}
        onClick={handleClickBack}
      >
        {lang("returnPreviousPage")}
      </Button>
    </Grid>
  );
};

Page404.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default Page404;
